import { useSigningState } from '@modusign/react-signing/setup';
import PropTypes from 'prop-types';
import PropsType from 'props-type';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { useMount, useUnmount } from 'react-use';

import { usePDF } from '@app/hooks/usePDF';
import documentAuthService from '@app/libs/auth/documentAuthService';
import { initializeContractAuthentication } from '@app/store/contract-authentication/actions';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {
  children: null,
};

type SigningLayoutProps = PropsType<typeof propTypes, typeof defaultProps>;

export function SigningLayout({ children }: SigningLayoutProps) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { i18n } = useTranslation();
  const { initialize } = useSigningState();
  const { resetPDF } = usePDF();

  const { state } = useLocation<{ contractLinkId?: string }>();
  const { contractLinkId } = state ?? {};

  useEffect(() => {
    if (!state) {
      // 정상적인 접근 플로우가 아닌 인위적으로 /signing/* 라우트로 접근한 경우 문서함으로 나가지도록 처리
      history.push('/');
    }
  }, [state, history]);

  useMount(() => {
    if (!contractLinkId) {
      // 링크서명의 경우 /link/:linkId/authentication 에서 인증정보룰 설정합니다.
      dispatch(initializeContractAuthentication());
    }
  });

  useUnmount(() => {
    initialize();
    resetPDF();
    i18n.changeLanguage('ko');
    documentAuthService.restoreTokens();
    dispatch(initializeContractAuthentication());
  });
  return children;
}

SigningLayout.propTypes = propTypes;
SigningLayout.defaultProps = defaultProps;

export default SigningLayout;
